import { useMemo } from 'react';
import { useQuery, gql } from '@apollo/client';

import { ADVANCE_DEDUCTIONS_LIST_FIELDS } from '../../apollo/fragments';

const useDeductionsQuery = (advance_id) => {
  const ADVANCE_DEDUCTIONS_QUERY = gql`
    ${ADVANCE_DEDUCTIONS_LIST_FIELDS}
    query AdvanceDeductions($advance_id: Int, $first: Int, $page: Int) {
      advanceDeductions(first: $first, page: $page, advance_id: $advance_id) {
        paginatorInfo {
          count
          currentPage
          total
        }
        data {
          ...AdvanceDeductionListFields
        }
      }
    }
  `;

  const queryVariables = useMemo(() => {
    console.log('fetchDeductions///queryVariables', advance_id);
    return {
      advance_id: parseInt(advance_id, 10),
      first: 100,
      page: 1,
    };
  }, [advance_id]);

  const { loading, data, refetch, networkStatus } = useQuery(
    ADVANCE_DEDUCTIONS_QUERY,
    {
      variables: queryVariables,
    }
  );

  const refetchDeductions = (advance_id) => {
    console.log('fetchDeductions///refetch', advance_id);
    if (advance_id) {
      refetch({
        advance_id: parseInt(advance_id, 10),
        first: 100,
        page: 1,
      });
    }
  };

  return { loading, data, networkStatus, refetchDeductions };
};
export default useDeductionsQuery;
